import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {TestResultQueryModel} from '../../models/test-result-query.model';
import {DocumentModel} from '../../models/document.model';

@Injectable()
export class TestResultService {
  basePath = 'laboratory-documents/';

  constructor(private apiService: ApiService) {

  }

  get(query: TestResultQueryModel): Observable<DocumentModel[]> {
    return this.apiService.post(this.basePath + 'search', query);
  }
}
